/**
 * The possible types of media.
 */
export enum MediaTypes {
  youtube = 'youtube',
  vimeo = 'vimeo',
  audio = 'audio',
  video = 'video',
}
